import React from 'react';
import { listStyles as s } from './listStyles';

// ACON-65: reusable clickable column header with an arrow indicator, shared by
// Invoices/Shipments (and the merged Inventory table). Sort values follow the
// existing "{field}_{asc|desc}" convention used across this codebase (e.g.
// "date_desc"), so this component just needs the field's key + the current
// `sortBy` string to derive active/direction state.
export function splitSort(sortBy) {
  if (!sortBy) return [null, null];
  const idx = sortBy.lastIndexOf('_');
  if (idx < 0) return [sortBy, 'asc'];
  return [sortBy.slice(0, idx), sortBy.slice(idx + 1)];
}

export default function SortableTh({ label, sortKey, sortBy, onSort, style }) {
  const [activeKey, activeDir] = splitSort(sortBy);
  const isActive = activeKey === sortKey;
  const nextDir = isActive && activeDir === 'asc' ? 'desc' : 'asc';

  return (
    <th
      style={{ ...s.sortableTh, ...style }}
      onClick={() => onSort(`${sortKey}_${nextDir}`)}
      role="button"
      aria-label={`Sort by ${label}`}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        {label}
        <span style={{ ...s.sortArrow, opacity: isActive ? 1 : 0.3 }}>
          {isActive && activeDir === 'desc' ? '▼' : '▲'}
        </span>
      </span>
    </th>
  );
}
